const QUESTION_UI = {
    station1: [
        {
            id: "q1",
            title: "คำถามข้อที่ 1",
            desc: 'Core Plus จ่ายโบนัสให้นักธุรกิจแอมเวย์มาแล้วทั้งหมดกี่บาท ?',
            options: [
                { id: "a", label: "5,000 ล้านบาท" },
                { id: "b", label: "5,500 ล้านบาท" },
            ],
            answer: "b",
        },
        {
            id: "q2",
            title: "คำถามข้อที่ 2",
            desc: "Core Plus สำหรับนักธุรกิจช่วงเริ่มต้นมีอะไรบ้าง ?",
            options: [
                { id: "a", label: "Go Bronze/BFI/BBI/OTCI" },
                { id: "b", label: "PGGI/FGI/TTCI/Come Back Incentive" },
            ],
            answer: "a",
        },
        {
            id: "q3",
            title: "คำถามข้อที่ 3",
            desc: "คูปองส่วนลดสูงสุดจากโปรแกรม A Joy ทั้งหมดกี่บาท ?",
            options: [
                { id: "a", label: "2,300 บาท" },
                { id: "b", label: "3,000 บาท" },
            ],
            answer: "a",
        },
    ],

    station2: [
        {
            id: "q1",
            title: "คำถามข้อที่ 1",
            desc: 'นิวทริไลท์เป็นเจ้าของฟาร์มออร์แกนิกจำนวนกี่แห่ง ?',
            options: [
                {
                    id: "a",
                    label: "4 แห่ง ใน 3 ประเทศ",
                },
                {
                    id: "b",
                    label: "3 แห่ง ใน 2 ประเทศ",
                },
            ],
            answer: "a",
        },
        {
            id: "q2",
            title: "คำถามข้อที่ 2",
            desc: "นิวทริไลท์ดูแลวัตถุดิบอย่างไรให้มั่นใจว่าปลอดภัยที่สุด?",
            options: [
                {
                    id: "a",
                    label: "ปลูกในฟาร์มออร์แกนิคของตัวเอง ตรวจสอบย้อนกลับได้ทุกขั้นตอน",
                },
                {
                    id: "b",
                    label: "ซื้อจากแหล่งวัตถุดิบที่ราคาถูกที่สุดเพื่อประหยัดต้นทุน",
                },
            ],
            answer: "a",
        },
        {
            id: "q3",
            title: "คำถามข้อที่ 3",
            desc: "โครงการ A Planet ของแอมเวย์ รณรงค์ให้คุณรักษ์โลกด้วยวิธีการใด?",
            options: [
                {
                    id: "a",
                    label: "Repair, นำเครื่องคอมพิวเตอร์ที่ชำรุดมาซ่อม",

                },
                {
                    id: "b",
                    label: "Recycle, คืนบรรจุภัณฑ์แอมเวย์เพื่อนำกลับมารีไซเคิล",
                },
            ],
            answer: "b",
        },
    ],

    station3: [
        {
            id: "q1",
            title: "คำถามข้อที่ 1",
            desc: "ส่วนผสมสำคัญใน Artistry Skin Nutrition คืออะไร ?",
            options: [
                { id: "a", label: "ดอกการ์ดิเนีย แกรนดิฟลอรา" },
                { id: "b", label: "เมล็ดเชียขาว" },
            ],
            answer: "b",
        },
        {
            id: "q2",
            title: "คำถามข้อที่ 2",
            desc: "ขั้นตอนการใช้ Artistry Omega Drops ที่ถูกต้อง คืออะไร ?",
            options: [
                { id: "a", label: "ใช้ก่อนเซรั่ม" },
                { id: "b", label: "ใช้หลังเซรั่ม" },
            ],
            answer: "b",
        },
        {
            id: "q3",
            title: "คำถามข้อที่ 3",
            desc: "สารขัดฟันในยาสีฟันกลิสเทอร์ คืออะไร ",
            options: [
                { id: "a", label: "ไฮเดรทเต็ท ซิลิก้า" },
                { id: "b", label: "รีมิแนกท์" },
            ],
            answer: "a",
        },
    ],

    station4: [
        {
            id: "q1",
            title: "คำถามข้อที่ 1",
            desc: "เครื่องกรองน้ำ อีสปริง ได้รับการรับรองมาตรฐานจากกี่สถาบัน ?",
            options: [
                { id: "a", label: "1 สถาบัน คือ มาตรฐานจาก NFS" },
                {
                    id: "b",
                    label: "2 สถาบัน คือ มาตรฐานจาก NSF และ มาตรฐานโกลด์ซีล จาก WQA",
                },
            ],
            answer: "b",
        },
        {
            id: "q2",
            title: "คำถามข้อที่ 2",
            desc: "เครื่องกรองอากาศ แอทโมสเฟียร์ สกาย เหมาะสำหรับห้องขนาดเท่าไหร่ ?",
            options: [
                { id: "a", label: "34 ตร.ม." },
                { id: "b", label: "43 ตร.ม." },
            ],
            answer: "b",
        },
        {
            id: "q3",
            title: "คำถามข้อที่ 3",
            desc: "สัญลักษณ์ Safer Choice หรือ ทางเลือกที่ปลอดภัยกว่า หมายความว่าอย่างไร ?",
            options: [
                {
                    id: "a",
                    label: "สูตรของผลิตภัณฑ์นี้มีส่วนผสมจากธรรมชาติ และมีความใส่ใจสิ่งแวดล้อม",
                },
                {
                    id: "b",
                    label: "สูตรของผลิตภัณฑ์นี้ช่วยลดแรงตึงผิว",
                },
            ],
            answer: "a",
        },
    ],

    station5: [
        {
            id: "q1",
            title: "คำถามข้อที่ 1",
            desc: "เว็บไซต์การเรียนรู้ใหม่ของแอมเวย์ชื่อว่าอะไร ?",
            options: [
                { id: "a", label: "Academy.amway.co.th" },
                { id: "b", label: "StudioABOthai.amway.com" },
            ],
            answer: "a",
        },
        {
            id: "q2",
            title: "คำถามข้อที่ 2",
            desc: "ฟีเจอร์จำลองยอด GPV ตามตะกร้าสินค้าเปิดให้ใช้งานบนช่องทางใด ?",
            options: [
                { id: "a", label: "A Click" },
                { id: "b", label: "Amway.co.th" },
            ],
            answer: "a",
        },
        {
            id: "q3",
            title: "คำถามข้อที่ 3",
            desc: "กฎทองของแอมเวย์ คืออะไร ?",
            options: [
                {
                    id: "a",
                    label: "จงยึดมั่นต่อระเบียบปฏิบัติอย่างเคร่งครัด",
                },
                {
                    id: "b",
                    label: "จงปฏิบัติต่อผู้อื่นดังเช่นที่คุณปรารถนาให้ผู้อื่นปฏิบัติต่อคุณ",
                },
            ],
            answer: "b",
        },
    ],
};

export default QUESTION_UI;